<template>
  <div class="box">
    <el-form
      :inline="true"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="80px"
    >
      <!-- <el-form-item label="公证类别" prop="lb">
        <el-select size="small" v-model="ruleForm.lb" :disabled="disabled" clearable placeholder="请选择">
          <el-option
            v-for="item in lbOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="公证事项" prop="notaryItem">
        <el-select
          size="small"
          v-model="ruleForm.notaryItem"
          :disabled="true"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in gzItems"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="公证费用" prop="charge">
        <el-input
          size="small"
          v-model="ruleForm.charge"
          :disabled="true"
          placeholder="请输入"
        >
        <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- <el-form-item label="公证类型" prop="lx">
        <el-select size="small" v-model="ruleForm.lx" :disabled="disabled" clearable placeholder="请选择">
          <el-option
            v-for="item in lxOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="公证员" prop="notaryId">
        <el-select
          size="small"
          v-model="ruleForm.notaryId"
          :disabled="status !== 1 || openType == 'see'"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in notarys"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="紧急程度" prop="priority">
        <el-select size="small" v-model="ruleForm.priority" :disabled="disabled" clearable placeholder="请选择">
          <el-option
            v-for="item in priorityOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="申请日期" prop="applyDate">
        <el-date-picker
          :disabled="disabled"
          size="small"
          v-model="ruleForm.applyDate"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item> -->

      <!-- <el-form-item v-if="openType==='edit' && status!==6" label="指派给" prop="owner">
        <el-select size="small" v-model="ruleForm.owner" clearable placeholder="请选择">
          <el-option
            v-for="item in notarys"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item> -->

      <!-- <el-form-item label="快递公司" v-if="status===5 && openType!=='add'">
        <el-select size="small" v-model="ruleForm.shipperName" clearable placeholder="请选择">
          <el-option
            v-for="item in kuaidiOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物流单号" v-if="status===5  && openType!=='add'">
        <el-input size="small" v-model="ruleForm.logisticCode">
        </el-input>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { conVertDate } from "@/utils/tools.js";
export default {
  props: {
    // disabled: {
    //   require: true
    // },
    openType: {
      type: String,
      required: true,
    },
    status: {
      type: Number,
      required: true,
    },
  },
  data() {
    var checkNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请填写价格"));
      } else if (!/^\d+$/.test(value)) {
        return callback(new Error("价格只能为数字"));
      } else {
        return callback();
      }
    };
    return {
      ruleForm: {
        charge: "", // 公证费用
        notaryItem: "", // 公证事项，传公证事项下来的id
        notaryId: "", // 公证员编码
        notaryName: "", // 公证员姓名
        owner: "", // 指派给谁
      },
      // ruleForm: {
      //   charge: "100", // 公证费用
      //   lb: '0', // 类别
      //   lx: '0', // 类型
      //   notaryItem: '0', // 公证事项，传公证事项下来的id
      //   notaryId: '0', // 公证员编码
      //   notaryName: "", // 公证员姓名
      //   priority: '0', // 紧急度
      //   acceptDate: "", // 日期
      //   applyDate: "", // 申请日期
      //   owner: '', // 指派给谁
      //   shipperName: '', // 快递公司
      //   logisticCode: '', // 物流单号
      // },
      rules: {
        lb: [{ required: true, message: "请选择类别", trigger: "change" }],
        lx: [{ required: true, message: "请选择类型", trigger: "change" }],
        notaryId: [
          { required: true, message: "请选择公证员", trigger: "change" },
        ],
        owner: [
          { required: true, message: "请选择下一环节处理公证员", trigger: "change" },
        ],
        priority: [
          { required: true, message: "请选择紧急程度", trigger: "change" },
        ],
        notaryItem: [
          { required: true, message: "请选择公证事项", trigger: "change" },
        ],
        applyDate: [
          { required: true, message: "请选择申请日期", trigger: "change" },
        ],
        charge: [
          { required: true, message: "请输入费用", trigger: "blur" },
          // { validator: checkNum, trigger: 'blur' }
        ],
      },
      lbOptions: [
        { label: "合同公证", value: "0" },
        { label: "电子存证", value: "1" },
        { label: "赋强公证", value: "2" },
      ],
      lxOptions: [{ label: "借款合同", value: "0" }],
      priorityOptions: [
        { label: "普通", value: "0" },
        { label: "加急", value: "1" },
      ],
      kuaidiOptions: [
        {
          value: "zhongtong",
          label: "中通快递",
        },
        {
          value: "yuantong",
          label: "圆通速递",
        },
        {
          value: "yunda",
          label: "韵达快递",
        },
        {
          value: "shentong",
          label: "申通快递",
        },
        {
          value: "shunfeng",
          label: "顺丰速运",
        },
        {
          value: "huitongkuaidi",
          label: "百世快递",
        },
        {
          value: "jd",
          label: "京东物流",
        },
        {
          value: " youzhengguonei",
          label: "邮政快递包裹",
        },
        {
          value: "youzhengbk",
          label: "邮政标准快递",
        },
        {
          value: "ems",
          label: "EMS",
        },
      ],
      disabled: true,
    };
  },
  computed: {
    ...mapGetters({
      storeCaseInfo: "case/caseInfo",
      notarys: "enum/notarys", // 公证员
      gzItems: "enum/gzItems", // 公证事项
    }),
  },
  watch: {
    // 案件信息
    storeCaseInfo: {
      immediate: true,
      deep: true,
      handler(newData) {
        this.ruleForm = { ...newData };
      },
    },
    // 公证事项
    gzItems: {
      immediate: true,
      handler(newArr) {
        // if (newArr.length !== 0) {
        //   this.ruleForm.notaryItem = newArr[0].value;
        // }
      },
    },
    // 公证员
    notarys: {
      immediate: true,
      handler(newArr) {
        // if (newArr.length !== 0) {
        //   this.ruleForm.notaryId = newArr[0].value;
        // }
      },
    },
    openType: {
      immediate: true,
      handler(newValue) {
        if (newValue === "see") {
          this.disabled = true;
        } else if (newValue === "add") {
          this.disabled = false;
        } else if (newValue === "edit") {
          if (this.status !== 0) {
            this.disabled = true;
          } else {
            this.disabled = false;
          }
        }
      },
    },
    status: {
      immediate: true,
      handler(newValue) {
        if (this.openType === "edit") {
          if (newValue !== 1) {
            this.disabled = true;
          } else {
            this.disabled = false;
          }
        } else if (this.openType === "add") {
          this.disabled = false;
        } else if (this.openType === "see") {
          this.disabled = true;
        }
      },
    },
  },
  mounted() {
    // this.ruleForm = this.caseInfoFormData;
  },
  methods: {
    async submitForm() {
      let flag;
      this.$refs.ruleForm.validate((valid) => {
        flag = valid;
        if (valid) {
          // this.ruleForm.notaryName = this.reverseSearch(this.ruleForm.notaryId, this.notarys);
          // this.ruleForm.acceptDate = conVertDate(new Date(), false);
          // this.ruleForm.applyDate = conVertDate(new Date(this.ruleForm.applyDate), false);
          this.$store.commit("case/updateCaseInfo", { ...this.ruleForm });
          console.log(this.$store.state.case.caseInfo);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      return flag;
    },
    // 通过value去查询options的label
    reverseSearch(value, options) {
      let label = null;
      options.forEach((item) => {
        if (item.value == value) {
          label = item.label;
          return;
        }
      });
      return label;
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-input {
  width: 150px;
}
</style>